import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDL = styled.dl.withConfig({
  displayName: "DescriptionList__StyledDL",
  componentId: "sc-151ngi-0"
})(({
  $cssStyles,
  theme: _theme
}) => {
  const theme = _theme;
  return Object.assign({
    margin: 0,
    '& dt': {
      fontSize: theme.typography['detail-200'].fontSize,
      color: theme.color['text-primary-subtle'],
      lineHeight: theme.typography['detail-200'].lineHeight
    },
    '& dd': {
      marginInlineStart: theme.space['0'],
      marginBlockEnd: theme.space['300']
    }
  }, $cssStyles);
});
export const DescriptionList = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledDL, Object.assign({}, domProps, {
    $cssStyles: cssStyles,
    children: children
  }));
};